import { CREATE_ROUTES } from '../../create/constants/create.constants'

/** Expo Router href for league detail with encoded query params. */
export function buildLeagueDetailHref(
  leagueName: string,
  leagueId: string,
  countryCode?: string,
): string {
  const params = new URLSearchParams({
    league: leagueName,
    leagueId,
  })
  if (countryCode != null && countryCode !== '') {
    params.set('countryCode', countryCode)
  }
  return `${CREATE_ROUTES.LEAGUE_DETAIL}?${params.toString()}`
}
